import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { gtm } from 'apps/gtm';
import { dynamicYieldService } from 'apps/dynamicYield';

export default class PageViewEvent extends PureComponent {
  static propTypes = {
    eventData: PropTypes.shape({
      pageType: PropTypes.string.isRequired,
      pageCategory: PropTypes.string,
      pageBreadcrumb: PropTypes.string,
      loggedInStatus: PropTypes.bool,
      userId: PropTypes.number,
      userRegistrationDate: PropTypes.string,
      userFirstPurchaseDate: PropTypes.string,
      userLastPurchaseDate: PropTypes.string,
      smartPass: PropTypes.bool,
      smartPassType: PropTypes.string,
      aisleId: PropTypes.number,
      placedOrderCount: PropTypes.number,
      basketValue: PropTypes.number,
      numberOfPurchaseLastTwelveMonths: PropTypes.number,
      sessionId: PropTypes.string,
      averageBasketValue: PropTypes.number,
      searchTerm: PropTypes.string,
      searchType: PropTypes.string,
      smartPassDuration: PropTypes.string,
      transactionId: PropTypes.number,
      hashedEmail: PropTypes.string,
      customerEmail: PropTypes.string,
      customerFirstName: PropTypes.string,
      customerLastName: PropTypes.string,
      pageViewId: PropTypes.string,
    }).isRequired,
  };

  componentDidMount() {
    this.fireEvent();
  }

  componentDidUpdate(prevProps) {
    const {
      eventData: {
        pageBreadcrumb,
        filters,
        sort,
      } = {},
    } = this.props;
    const {
      eventData: {
        pageBreadcrumb: prevPageBreadcrumb,
        filters: prevFilters,
        sort: prevSort,
      } = {},
    } = prevProps;
    // Fire additional event if navigation occured in the same PageComponent
    if (
      (pageBreadcrumb !== prevPageBreadcrumb)
      || (filters !== prevFilters)
      || (sort !== prevSort)
    ) this.fireEvent();
  }

  fireEvent() {
    const {
      user,
      basket,
      analytics,
      eventData,
    } = this.props;
    const {
      pageType,
      pageCategory,
      pageBreadcrumb,
      aisleId,
      searchTerm,
      searchType,
    } = eventData;

    const customerNum = get(user, 'customerNum');

    // fire GTM pageview event
    gtm.trigger('gtm:pageView', {
      pageType,
      pageCategory,
      pageBreadcrumb,
      loggedInStatus: !!customerNum,
      userId: customerNum,
      userRegistrationDate: get(user, 'customerDetails.userRegistrationDate'),
      userFirstPurchaseDate: get(user, 'shoppingDetails.userFirstPurchaseDate'),
      userLastPurchaseDate: get(user, 'shoppingDetails.userLastPurchaseDate'),
      smartPass: get(user, 'eligibilityDetails.smartPassEligibility') === 'SUBSCRIBED',
      smartPassType: get(user, 'eligibilityDetails.smartPassType'),
      aisleId,
      placedOrderCount: get(user, 'shoppingDetails.placedOrdersCount'),
      basketValue: get(basket, 'value'),
      numberOfPurchaseLastTwelveWeeks: get(user, 'shoppingDetails.numberOfPurchasesLastTwelveMonths'),
      sessionId: get(user, 'customerDetails.sessionId'),
      averageBasketValue: get(user, 'shoppingDetails.averageBasket', 0),
      searchTerm,
      searchType,
      smartPassDuration: get(user, 'eligibilityDetails.smartPassDuration'),
      transactionId: get(basket, 'orderNo'),
      hashedEmail: get(user, 'customerDetails.emailToken'),
      customerEmail: get(user, 'customerDetails.email'),
      customerFirstName: get(user, 'customerDetails.firstName'),
      customerLastName: get(user, 'customerDetails.lastName'),
      pageViewId: get(analytics, 'pageView.id'),
      vouchers: get(user, 'shoppingDetails.voucherDtos'),
    });

    // Fire DY sunc cart event (see https://support.dynamicyield.com/hc/en-us/articles/360023172893-Events-for-Web#h_01EX9ZJHA5QX7169XRXACAM81A)
    dynamicYieldService.reportSyncCartEvent({ basketItems: get(basket, 'items', []) });
  }

  render() {
    return null;
  }
}
